module.exports = __webpack_public_path__ + "img/van03.5124abd7.png";